export const routesAndLinesTestIds = {
  observationDateInput: 'SearchContainer::observationDateInput',
  lineTypeDropdown: 'SearchContainer::lineTypeDropdown',
  prefix: 'SearchContainer',
};
